import { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { TenantCompanyService as Service } from './TenantCompanyService';
import { CityService } from './CityService';
import { TaxAuthorityService } from './TaxAuthorityService';
import { AppStorage } from '../../../../service/UserStorage';
import { TenantCompanyHistoryService } from './TenantCompanyHistoryService';

import { useForm } from '../../../../shared/hooks/Form';
import { useDataTable } from '../../../../shared/hooks/DataTable';
import { ToastService } from '../../../../AppToast';

export const Detail = () => {

  const [submitting, setSubmitting] = useState(false);
  const [displayLogs, setDisplayLogs] = useState(false);
  const [originData, setOriginData] = useState(null);
  const [hidenIdentityCode, setHidenIdentityCode] = useState(false);
  const companyTypes = [
    {value: '01', label: 'Doanh nghiệp vàng bạc'},
    {value: '03', label: 'Doanh nghiệp'},
    {value: '02', label: 'Hộ kinh doanh cá thể'},
    {value: '04', label: 'Nhà hàng / quán ăn'}
  ];
  const [cities, setCities] = useState([]);
  const [taxAuthorities, setTaxAuthorities] = useState([]);

  useEffect(() => {
    CityService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setCities(items);
    });
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (originData && originData.cityCode && cities && cities.length) {
      cities.forEach(city => {
        if (city.code === originData.cityCode) {
          originData.city = city;
          setValue(originData);
        }
      });
    }
  }, [originData, cities]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (originData && originData.taxAuthorityCode && taxAuthorities && taxAuthorities.length) {
      taxAuthorities.forEach(taxAuthority => {
        if (taxAuthority.code === originData.taxAuthorityCode) {
          originData.taxAuthority = taxAuthority;
          setValue(originData);
          setOriginData(null);
        }
      });
    }
  }, [originData, taxAuthorities]); // eslint-disable-line react-hooks/exhaustive-deps

  const { render: renderForm, setValue, valid: formValid, getValue } = useForm({
    fields: [
      { field: 'taxCode', header: 'Mã số thuế', disabled: true, InputTextProps: { maxLength: 50 }, className: 'md:col-2' },
      // {field: 'identityCode', header: 'Mã cơ quan thuế cấp', disabled: true, InputTextProps: {maxLength: 50}, className: 'md:col-2'},
      { field: 'name', header: 'Tên đơn vị', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-10' },
      { field: 'address', header: 'Địa chỉ', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-9' },
      { field: 'province', header: 'Tỉnh thành', required: false, InputTextProps: { maxLength: 50 }, className: 'md:col-3' },
      { field: 'delegate', header: 'Người đại diện pháp luật', InputTextProps: { maxLength: 400 }, className: 'md:col-6' },
      { field: 'position', header: 'Chức vụ', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'email', header: 'Email', type: 'email', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'tel', header: 'Điện thoại', InputTextProps: { maxLength: 15 }, className: 'md:col-6' },
      { field: 'webSite', header: 'WebSite', InputTextProps: { maxLength: 250 }, className: 'md:col-6' },
      { field: 'fax', header: 'Fax', InputTextProps: { maxLength: 15 }, className: 'md:col-6' },
      { field: 'bankAccount', header: 'Tài khoản', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'bankName', header: 'Tại ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-6' },
      // {field: 'city', header: 'CQ thuế cấp tỉnh', type: 'Dropdown', DropdownProps: {options: cities, optionLabel: 'name', filter: true, resetFilterOnHide: true}, className: 'md:col-6'},
      // {field: 'taxAuthority', header: 'CQ thuế quản lý', type: 'Dropdown', DropdownProps: {options: taxAuthorities, optionLabel: 'name', filter: true, resetFilterOnHide: true}, className: 'md:col-6'},
      { field: 'nameShort', header: 'Tên trên viết tắt', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-6' },
      { field: 'addressShort', header: 'Địa chỉ trên viết tắt', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-6' },
      { field: 'companyType', header: 'Loại hình doanh nghiệp', type: 'Dropdown', DropdownProps: { options: companyTypes, optionLabel: 'label', filter: true, resetFilterOnHide: true }, className: 'md:col-6' },
    ]
  });

  const { city } = getValue();
  useEffect(() => {
    if (city && city.code) {
      TaxAuthorityService.getList({ cityCode: city.code, maxResultCount: 1000 }).then(({ items }) => {
        setTaxAuthorities(items);
      });
    }
  }, [city]);

  const load = () => {
    Service.get(AppStorage.get('__tenant')).then((data) => {
      setOriginData(data);
      setValue(data);
    });
  }

  const handleSubmit = () => {
    if (!submitting && formValid()) {
      setSubmitting(true);

      const data = getValue();

      if (data.city) {
        data.cityCode = data.city.code;
        data.cityName = data.city.name;
        delete data.city;
      }
      if (data.taxAuthority) {
        data.taxAuthorityCode = data.taxAuthority.code;
        data.taxAuthorityName = data.taxAuthority.name;
        delete data.taxAuthority;
      }

      Service.update(AppStorage.get('__tenant'), data).then(() => {
        AppStorage.set('tenantInfo', JSON.stringify(data))
        ToastService.success();
        load();
      }).finally(() => {
        window.location.reload()
        setSubmitting(false);
      });
    }
  }

  const { render: renderDataTable, reloadLazyData } = useDataTable({
    header: 'Lịch sử thay đổi',
    dataKey: 'id',
    columns: [
      { field: 'creatorName', header: 'Người sửa', width: 160 },
      { field: 'lastModificationTime', header: 'Ngày sửa', width: 180, dataType: 'date' },
      { field: 'name', header: 'Dữ liệu', minWidth: 200 }
    ],
    indexColumnWidth: 40,
    selectionMode: 'single',
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const showLogsDialog = () => {
    reloadLazyData();
    setDisplayLogs(true);
  }

  return (
    <div className="surface-card p-5" style={{ width: '1300px', margin: '0 auto' }}>
      {renderForm()}

      <div className="flex justify-content-end">
        <Button label="Xem lịch sử thay đổi" icon="pi pi-clock" onClick={() => showLogsDialog()} className="p-button-text p-button-sm" />
        <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
      </div>

      <Dialog header="Lịch sử thay đổi thông tin" visible={displayLogs} style={{ width: '80rem' }} position="top" onHide={() => setDisplayLogs(false)}>
        {renderDataTable()}

        <div className="flex justify-content-end mt-3">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplayLogs(false)} className="p-button-text p-button-sm" />
        </div>
      </Dialog>
    </div>
  )
}
